import {createBrowserRouter, RouterProvider, Navigate} from 'react-router-dom';
import './App.css';
import Container from 'react-bootstrap/Container';
import NotFound from './components/NotFound';
import MdgRatings from './components/MdgFriends';
import LdgcRatings from './components/LDGC';
import MdgtRatings from './components/MDGT';
import AdgRatings from './components/ADG';
import Home from './components/Home';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
    errorElement: <NotFound />
  },
  {
    path: '/friends',
    element: <MdgRatings />
  },
  {
    path: 'mdgt',
    element: <MdgtRatings />
  },
  {
    path: 'ldgc',
    element: <LdgcRatings />
  },/* ,
  {
    path: 'login',
    element: <Login />
  } */
  {
    path: 'adg',
    element: <AdgRatings />
  },
  {
    path: 'ace',
    element: <Navigate to="/adg" replace />
  }
]);

function App() {
  return (
    <Container fluid>
      <RouterProvider router={router} />
    </Container>
    // <footer>&copy; 2023 Maximilian Berkmann</footer>
  );
}

export default App;
